import React, { Component, useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import ReactSelect from "components/ReactSelect"
import submitData from "helpers/submitData"
import numeral from "numeral"

function QuarterlyLotSales(props) {
	const [ready, setReady] = useState(false)
	const [opts, setOpts] = useState({ builder: 0, lot_type: 0, section_id: 0 })
	const [rows, setRows] = useState([])

	const quarters = []
	for (let i = 0; i < 7; i++) {
		let q = moment().add(i, "quarter")
		let header = q.format("[Q]Q Y")
		quarters.push(header)
	}
	const columns = [
		{
			accessor: "section",
			display: true,
			Header: "Section",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
	]
	for (let i = 0; i < 7; i++) {
		let q = moment().add(i, "quarter")
		let header = q.format("[Q]Q Y")
		let access = q.format("[Q]Q-Y")
		columns.push({
			accessor: access,
			display: true,
			Header: header,
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v[access]) {
						total += parseFloat(v[access])
					}
				})
				return total
			},
		})
	}

	useEffect(() => {
		lookupData()
	}, [])

	useEffect(() => {
		lookupData()
	}, [props.activeProperties])

	const lookupData = async () => {
		if(props.activeProperties.length == 0) return
		props.loadingStatus(true)
		submitData("lotSalesStatusLookup", { property: props.activeProperties[0], multi: true })
			.then((resp) => {
				buildTable(resp.data)
				props.loadingStatus(false)
			})
			.catch((e) => {
				console.error(e)
				props.loadingStatus(false)
				setRows([])
			})
	}	

	const buildTable = rawData => {
		let ret = []
		let store = {}
		_.forEach(rawData, v => {
			if(!v.data) return
			try {
				_.forEach(v.data, (r,k) => {
					let m = moment(k, "MMM-YY").format("[Q]Q-Y")
					let h = moment(k, "MMM-YY").format("[Q]Q Y")
					if(quarters.includes(h)) {
						let path = `${v.section_id}.${m}`
						if(!_.has(store, path)) {
							_.setWith(store, path, 0, Object)
						}
						store[v.section_id][m] += r
					}
				})
				
			} catch (e) {
				console.log(e)
			}
		})
		_.forEach(store, (qs, sectionID) => {
			let sec = _.find(props.payload.public.sections, {id: parseInt(sectionID)})
			let f = {
				section: sec.name
			}
			if(!sec) return
			_.forEach(qs, (v, quarter) => {
				f[quarter] = v
			})
			ret.push(f)
		})
		setRows(ret)
	}

	if (props.activeProperties.length !== 1) {
		return (
			<div className="pleaseChoose">
				<h1>Please choose one community to view.</h1>
			</div>
		)
	} else if (props.payloadStatus) {
		return (
			<div>
				<div className="imageGroup">
					<Title title="Quarterly Lot Takedowns" showDate={false} />
					<div className="content">
						<FullTable
							data={rows}
							columns={columns}
							name="quarterlyTakedowns"
							title="Quarterly Lot Takedowns"
							classNames="small"
							pageSize={10}
						/>
					</div>
				</div>
			</div>
		)
	}
	return ""
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(QuarterlyLotSales)
